import Biological from "../../../views/practice/biological/Biological";
import ConfirmAutoclaveType from "../../../views/practice/biological/ConfirmAutoclaveType";

const biologicalRoutes = [
  {
    path: '/practice/biological',
    element: <Biological />
  },
  {
    path: '/practice/biological/confirm-autoclave-type',
    element: <ConfirmAutoclaveType />
  }
];

export default biologicalRoutes;
